import { msg } from '@lingui/macro';
import { IconRefresh } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productMasterListSync',
  status: 'legacy',
  category: 'master-list',
  icon: IconRefresh,
  title: msg`Master list sync (legacy)`,
  shortTitle: msg`Master list sync (legacy)`,
  whenToUse: msg`Synchronizes a current master list with source data. Superseded by the standard Master list import.`,
  outputDescription: msg`Synchronizes a master list against fresh source data (legacy).`,
  intents: ['Legacy master list sync'],
  keywords: ['legacy', 'sync', 'master list'],
  synonyms: [],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: [],
    requiredColumns: [],
  },
};

export default descriptor;
